// @flow weak

import _ from 'lodash';
import { connect } from 'react-redux';

import { isUrlBlacklisted } from '@zapier/url-utils';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import * as RouterSelectors from 'app/common/utils/RouterSelectors';
import AppNav from 'app/common/components/AppNav';
import MaybeLoad from 'app/common/components/MaybeLoad';
import hocify from 'app/common/components/hocify';
import maybeRender from 'app/common/components/maybeRender';

// Paths (or partial paths) that shouldn't render `AppNav`
const blacklisted = ['/developer/'];

const mapStateToProps = state => {
  const currentUrl = RouterSelectors.currentUrl(state) || '';
  const isLoggedIn = Profile.selectors.all.isLoggedIn(state);

  const items = [
    { text: 'Dashboard', url: '/app/dashboard' },
    { text: 'My Zaps', url: '/app/zaps' },
    { text: 'Task History', url: '/app/history' },
    { text: 'My Apps', url: '/app/connections' },
  ];

  return {
    canSwitchAccounts: Account.selectors.all.hasMultiple(state),
    currentUrl,
    items,
    shouldShow: isLoggedIn && !isUrlBlacklisted(currentUrl, blacklisted),
  };
};

const mapDispatchToProps = dispatch => ({
  onLoad() {
    dispatch(Account.actions.loadCollection());
    dispatch(Profile.actions.loadCollection());
  },
});

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  hocify(MaybeLoad),
  maybeRender(props => props.shouldShow)
)(AppNav);
